import { hexColorToRGBA } from '@/views/chart/chart/util'
import { componentStyle, seniorCfg } from '../common/common'
import { BASE_ECHARTS_SELECT, DEFAULT_TOOLTIP } from '@/views/chart/chart/chart'
import * as echartsUtils from '@/utils/echartsUtils'


export function baseMixOption(chart_option, chart) {

  console.log("mix--_option----------")
  console.log(chart_option, chart)

  // 处理shape attr
  let customAttr = {}
  const yAxis = JSON.parse(chart.yaxis)
  //if (chart.customAttr) {
  customAttr = JSON.parse(chart.customAttr)
  if (customAttr.color) {
    chart_option.color = customAttr.color.colors
  }
  // tooltip
  // if (customAttr.tooltip) {
  const tooltip = JSON.parse(JSON.stringify(customAttr.tooltip))
  const reg = new RegExp('\n', 'g')
  tooltip.formatter = tooltip.formatter.replace(reg, '<br/>')
  // chart_option.tooltip = tooltip

  const bgColor = tooltip.backgroundColor ? tooltip.backgroundColor : DEFAULT_TOOLTIP.backgroundColor
  chart_option.tooltip.backgroundColor = bgColor
  chart_option.tooltip.borderColor = bgColor
  chart_option.tooltip.axisPointer = {
    "type": "cross"
  }
  chart_option.tooltip.trigger = "axis"

  chart_option.axisPointer = {
    "link": {
      "xAxisIndex": "all"
    },
    "label": {
      "backgroundColor": "#777"
    }
  }

  chart_option.grid = {
    "top": 42,
    "left": 65,
    "borderWidth": 0,
    "bottom": 40,
    "show": true,
    "right": 10
  }
  // }

  //}

  //if(chart.data){
  // chart_option.title.text = chart.title
  //chart_option.xAxis.data = chart.data.x

  /**
   *   "legend": {
   *     "data": ["2021-预估", "2022-预估", "2021-实际", "2022-实际"],
   *     "orient": "horizontal",
   *     "top": 5,
   *     "itemHeight": 7,
   *     "icon": "circle",
   *     "textStyle": {
   *       "color": "#333"
   *     },
   *     "right": 10
   *   },
   *
   */
  chart_option.legend = {
    //  "data": ["2021-预估", "2022-预估", "2021-实际", "2022-实际", "2021-转化率", "2022-转化率"],
    "orient": "horizontal",
    "top": "bottom",
    "left": "left",
    "itemHeight": 7,
    "icon": "circle",
    "textStyle": {
      "color": "#333"
    },
    "right": 10
  }

  let data_arr_year=[]
  let data_arr_month=[]
  chart.data.x.forEach((item, index) => {
    let split = item.split("\n");
    if (split.length < 2) {
      split = item.split("-");
    }
    const year = parseInt(split[0]), month = parseInt(split[1]);
    data_arr_year.push(year);
    data_arr_month.push(month);
  });

  console.log(data_arr_year);
  console.log(data_arr_month);

  console.log(chart.data.series)


  /*  chart_option.series=[
      {
        "barMaxWidth": 40,
        "data": [3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782],
        "name": "2021-正式",
        "itemStyle": {
          // "color": new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#4864a5'},{offset: 0.5, color: '#4864a5'},{offset: 1, color: '#4864a5'}]),
          "borderRadius": 0
        },
        "type": "bar",
        "barMinHeight": 1,
        "stack": "2021-正式",
        emphasis: {
          focus: 'series'
        },
      },
      {
        "stack": "2021-正式",
        emphasis: {
          focus: 'series'
        },
        "barMaxWidth": 40,
        "data": [42158.00, 42158, 42158, 42158, 42158, 18638408.24, 40282729.20, 2828157.29, 23098336.81, 18710061.34, 16207588.14],
        "name": "2022-正式",
        "itemStyle": {
          // "color": new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#dae0ec'},{offset: 0.5, color: '#dae0ec'},{offset: 1, color: '#dae0ec'}]),
          "borderRadius": 0
        },
        "type": "bar",
        "barMinHeight": 1
      },

      {
        "stack": "2021-非正式",
        "barMaxWidth": 40,
        "data": [3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782],
        "name": "2021-非正式",
        "itemStyle": {
          // "color": new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#4864a5'},{offset: 0.5, color: '#4864a5'},{offset: 1, color: '#4864a5'}]),
          "borderRadius": 0
        },
        emphasis: {
          focus: 'series'
        },
        "type": "bar",
        "barMinHeight": 1
      },
     {
        "stack": "2022-非正式",
        "barMaxWidth": 40,
        "data": [42158.00, 42158, 42158, 42158, 42158, 18638408.24, 40282729.20, 2828157.29, 23098336.81, 18710061.34, 16207588.14],
        "name": "2022-非正式",
        "itemStyle": {
          // "color": new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#dae0ec'},{offset: 0.5, color: '#dae0ec'},{offset: 1, color: '#dae0ec'}]),
          "borderRadius": 0
        },
        emphasis: {
          focus: 'series'
        },
        "type": "bar",
        "barMinHeight": 1
      },
      {
        "symbol": "circle",
        "barMaxWidth": 40,
        "data": [42158.64, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782],
        "symbolSize": 6,
        "name": "2021-转化率",
        "itemStyle": {
          //  "color": new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#6D7A88'},{offset: 0.5, color: '#6D7A88'},{offset: 1, color: '#6D7A88'}]),
          "borderRadius": 0
        },
        "type": "line",
        "showAllSymbol": true,
        "barMinHeight": 1,
        "yAxisIndex": 1
      }, {
        "symbol": "circle",
        "barMaxWidth": 40,
        "data": [16576829.834880002, 5879538.541839999, 6213782.319839998, 18127255.973459996, 24069481.94542, 24281877.561140005, 24407176.6271, 25162043.773880005, 22115880.878799994, 24903844.0478, 1093409.9205999998],
        "symbolSize": 6,
        "name": "2022-转化率",
        "itemStyle": {
          // "color": new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#E3E5E6'},{offset: 0.5, color: '#E3E5E6'},{offset: 1, color: '#E3E5E6'}]),
          "borderRadius": 0
        },
        "type": "line",
        "showAllSymbol": true,
        "barMinHeight": 1,
        "yAxisIndex": 1
      }
    ];

  } */

  // 处理data
  if (chart.data) {
    chart_option.title.text = chart.title
   // chart_option.xAxis.data = chart.data.x
    for (let i = 0; i < chart.data.series.length; i++) {
      const y = chart.data.series[i]
      y.type = y.type ? y.type : 'bar'
      // color
      y.itemStyle = {
        color: hexColorToRGBA(customAttr.color.colors[i % customAttr.color.colors.length], customAttr.color.alpha)
      }
      // size
      if (customAttr.size) {
        // bar
        if (y.type === 'bar') {
          if (customAttr.size.barDefault) {
            y.barWidth = null
            y.barGap = null
          } else {
            y.barWidth = customAttr.size.barWidth
            y.barGap = customAttr.size.barGap
          }
        }
        // line
        if (y.type === 'line') {
          y.symbol = customAttr.size.lineSymbol
          y.symbolSize = customAttr.size.lineSymbolSize
          y.lineStyle = {
            width: customAttr.size.lineWidth,
            type: customAttr.size.lineType
          }
          y.smooth = customAttr.size.lineSmooth
        }
        // scatter
        if (y.type === 'scatter') {
          y.symbol = customAttr.size.scatterSymbol ? customAttr.size.scatterSymbol : 'circle'
          y.symbolSize = customAttr.size.scatterSymbolSize ? customAttr.size.scatterSymbolSize : 20
        }
      }
      // label
      if (customAttr.label) {
        y.label = customAttr.label
      }
     // chart_option.legend.data.push(y.name)
      i >= yAxis.length ? (y.yAxisIndex = 1) : (y.yAxisIndex = 0)

      y.selectedMode = true
      y.select = BASE_ECHARTS_SELECT

      console.log(y)
      chart_option.series.push(y)
    }
  }




  componentStyle(chart_option, chart)
  seniorCfg(chart_option, chart)
  let chart_option2 = echartsUtils.loopChartJson(chart_option);
  return chart_option2
}
